<div>
  <p class="p1">
    {{ 'History: ' | trans:'customers/customer-details-modal/actions/history.Label' }}
  </p>

  <div class="m-t-16">
    @if (isLoading()) {
      <div class="d-flex justify-content-center">
        <app-loader />
      </div>
    } @else {
      <table class="base-2">
        <thead>
        <tr class="text-right">
          <th>
            {{ 'Action' | trans:'customers/customer-details-modal/actions/action.Label' }}
          </th>
          <th>
            {{ 'Status' | trans:'customers/customer-details-modal/actions/status.Label' }}
          </th>
          <th>
            {{ 'Date' | trans:'customers/customer-details-modal/actions/date.Label' }}
          </th>
          <th>
            {{ 'Colleague' | trans:'customers/customer-details-modal/actions/colleague.Label' }}
          </th>
        </tr>
        </thead>
        <tbody>
          @for (action of data; track action.customerActionId) {
            <tr class="text-right">
              <td>
                <p class="p2 c-t-blue-700">
                  {{ action.actionTypeKey | trans:'customers/customer-details-modal/actions/actionTypeKey.' + action.actionTypeKey }}
                </p>
              </td>
              <td>
                <div class="tag tag--{{ action.statusKey }} to-right">
                  {{ action.statusKey | trans:'customers/customer-details-modal/actions/statusKey.' + action.statusKey }}
                </div>
              </td>
              <td>
                <p class="p2">
                  {{ action.actionDate | localeDatetimeFormat }}
                </p>
              </td>
              <td>
                <p class="p2">
                  {{ action.actionEmployeeName }}
                </p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
